import { useContext, useEffect } from 'react';
import { ActionType } from '../../state/GlobalState';
import { AppContext } from '../../state/AppContextProvider';
import { useWP } from '../../hooks/WPHooks';

export const ParentTagsLoader = () => {
  const { state, dispatch } = useContext(AppContext);

  const { wp } = useWP();

  useEffect(() => {
    if (state.isConnected === true && state.parentTags.length === 0) {
      wp.getParentTags('tax-tag').then((res) => {
        dispatch({ type: ActionType.SetParentTags, payload: res });
      });

      wp.getParentTags('places-categories').then((res) => {
        dispatch({ type: ActionType.SetPlaceTags, payload: res });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isConnected]);

  return <></>;
};
